<div class="modal-header">
    <h5 class="modal-title">Parts Attachments</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <swiper-container
      [attr.initial-slide]="startIndex"
      pagination="true"
      navigation="true"
      style="width: 100%; height: auto;"
    >
      <swiper-slide *ngFor="let img of images">
        <div class="slide-image-wrapper">
          <img [src]="img" alt="Attachment Image" />
        </div>
      </swiper-slide>
    </swiper-container>
  </div>
